import { createSlice } from "@reduxjs/toolkit";
import { AddHDD, UpdateHDD, GetHDDList } from "services/other/hdd.service";
import { toast } from 'react-toastify';

export const hddAddSlice = createSlice({
  name: "hddAdd",
  initialState: {
    hddAdd: {},
    hddAddLoading: false,
    hddAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddHDD.pending, (state) => {
      // toast.loading('We are adding the hdd 🤯')
      state.hddAddLoading = true
    });

    builder.addCase(AddHDD.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New hdd added successfully 👌');

      state.hddAdd = action.payload
      state.hddAddLoading = false
      state.hddAddError = null
    });

    builder.addCase(AddHDD.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the hdd 😣")

      state.hddAddLoading = false
      state.hddAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const hddUpdateSlice = createSlice({
  name: "hddUpdate",
  initialState: {
    hddUpdate: {},
    hddUpdateLoading: false,
    hddUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateHDD.pending, (state) => {
      // toast.loading('We are updating the hdd 🤯')
      state.hddUpdateLoading = true
    });

    builder.addCase(UpdateHDD.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.hddUpdate = action.payload
      state.hddUpdateLoading = false
      state.hddUpdateError = null
    });

    builder.addCase(UpdateHDD.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the hdd 😣")

      state.hddUpdateLoading = false
      state.hddUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const hddListSlice = createSlice({
  name: "hddList",
  initialState: {
    hddList: [],
    hddListLoading: false,
    hddListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetHDDList.pending, (state) => {
      state.hddListLoading = true
    });

    builder.addCase(GetHDDList.fulfilled, (state, action) => {
      toast.dismiss();

      state.hddList = action.payload
      state.hddListLoading = false
      state.hddListError = null
    });

    builder.addCase(GetHDDList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the hdd 😣")

      state.hddListLoading = false
      state.hddListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});